import apiClient from './client';
import { API_PATHS } from '../utils/constants';

function unwrapResponsePayload(responseData) {
  return responseData?.data ?? responseData;
}

export async function loginUser(payload) {
  const { data } = await apiClient.post(API_PATHS.auth.login, payload);
  return unwrapResponsePayload(data);
}

export async function getCurrentUser() {
  const { data } = await apiClient.get(API_PATHS.auth.me);
  return unwrapResponsePayload(data);
}

export async function getAllUsers() {
  const { data } = await apiClient.get(API_PATHS.auth.users);
  return unwrapResponsePayload(data);
}

export async function registerUser(payload) {
  const { data } = await apiClient.post(API_PATHS.auth.register, payload);
  return unwrapResponsePayload(data);
}

export async function updateUser(userId, payload) {
  const { data } = await apiClient.patch(
    `${API_PATHS.auth.users}/${encodeURIComponent(String(userId))}`,
    payload,
  );
  return unwrapResponsePayload(data);
}

export async function deleteUser(userId) {
  const { data } = await apiClient.delete(
    `${API_PATHS.auth.users}/${encodeURIComponent(String(userId))}`,
  );
  return unwrapResponsePayload(data);
}
